export const TRAVEL_AGENCY_URL = "https://www.torn.com/page.php?sid=travel";

export function attackUrl(userId) {
  return `https://www.torn.com/page.php?sid=attack&user2ID=${userId}`;
}

export function itemMarketUrl(itemId) {
  return `https://www.torn.com/page.php?sid=ItemMarket#/market/view=search&itemID=${itemId}&sortField=price&sortOrder=ASC`;
}

export function itemImageUrl(itemId) {
  return `https://www.torn.com/images/items/${itemId}/large.png`;
}

// Untradable loot has no market listing, so it opens its Wiki page instead.
export function lootItemUrl(item) {
  return item.wikiOnly
    ? `https://wiki.torn.com/wiki/${encodeURIComponent(
        item.name.replace(/ /g, "_")
      ).replace(/'/g, "%27")}`
    : itemMarketUrl(item.id);
}
